// assets
import { Story, DollarSquare, Candle, CpuSetting, Calculator, Bank } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  candles: Candle,
  instruments: CpuSetting,
  historicData: Candle,
  calculator: Calculator,
  brokers: Bank,
  widgets: Story,
  prices: DollarSquare
};

const app: NavItemType = {
  id: 'App',
  title: 'App',
  icon: icons.widgets,
  type: 'group',
  children: [

    {
      id: 'brokers',
      title: 'Brokers',
      type: 'item',
      url: '/brokers',
      breadcrumbs: true,
      icon: icons.brokers
    },
    {
      id: 'vealth1st-calcultor',
      title: 'Vealth1st Calculator',
      type: 'item',
      url: '/vealth1st-calculator',
      breadcrumbs: true,
      icon: icons.calculator
    },
    {
      id: 'Instruments',
      title: 'Instruments',
      type: 'item',
      url: '/instruments',
      icon: icons.instruments
    }
  ]
};

export default app;
